<plugin-preview-chrome
  [config]="config"
  [zipCodeAvailableControl]="zipCodeAvailableControl"
  [variantAvailabilityControl]="variantAvailabilityControl"
  [themeEditorUrl]="themeEditorUrl">
  <ng-template>
    <div class="icon-container">
      @if (iconPreview) {
        <img [src]="iconPreview" />
      }
    </div>
    @if (zipCodeAvailableControl.value) {
      <div class="promise">
        @if (config?.fastestShipping) {
          <div class="fastest-section">
            <li>
              @if (config?.fastestShipping?.enabled) {
                <span
                  [innerHTML]="
                    config?.fastestShipping?.pattern | shippingTextPattern: fastestTextPipeArg | safe
                  "></span>
              }
            </li>
          </div>
        }
        @if (config?.cheapestShipping?.enabled) {
          <li
            [innerHTML]="
              config.cheapestShipping?.freeShippingPattern
                | shippingTextPattern
                  : freeTextPipeArg
                  : (+config?.cheapestShipping?.cartValueThreshold
                      ? ' (for orders above ' + currencySymbol + config?.cheapestShipping?.cartValueThreshold + ')'
                      : '')
                | safe
            "></li>
        }
        @if (config?.cheapestShipping?.enabled) {
          @switch (variantAvailabilityControl.value) {
            @case ('inStock') {
              <span
                [innerHTML]="
                  config?.inventoryConfig?.inStockPattern | shippingTextPattern: inStockTextPipeArg | safe
                "></span>
            }
            @case ('partiallyInStock') {
              <span
                [innerHTML]="
                  config?.inventoryConfig?.partiallyInStockPattern | shippingTextPattern: partialStockTextPipeArg | safe
                "></span>
            }
            @case ('outOfStock') {
              <span
                [innerHTML]="
                  config?.inventoryConfig?.outOfStockPattern | shippingTextPattern: outOfStockTextPipeArg | safe
                "></span>
            }
          }
        }
        @if (config?.design.template === DesignTemplate.DEFAULT) {
          <li>
            Ship to <b><u>051545</u></b>
          </li>
        }
      </div>
    } @else {
      <div class="input-preview">
        @if (config?.design?.widgetTitle) {
          <p class="title">{{ config?.design?.widgetTitle }}</p>
        }
        <div class="input-preview__input-container">
          <input [placeholder]="config?.design?.inputPlaceholder" />
          <button
            [ngStyle]="{
              'padding-left': config?.design?.buttonPadding + 'px',
              'padding-right': config?.design?.buttonPadding + 'px',
            }">
            {{ config?.design?.buttonText }}
          </button>
        </div>
      </div>
    }
  </ng-template>
</plugin-preview-chrome>
